import {pageInfo, exportData, details, editInit, submit, initPurchOrder} from './../api';
import {storageList, plant, weighBusinessType, selectStorageBatchByStorageId} from '../../../../api'
import {Message} from 'element-ui';

const weighRedFlush = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportObj: [],
    detailsObj: null,
    businessTypeObj: null,
    editinitDataObj: null,
    submitDataObj: null,
    initPurchOrderDataObj: null,
    storageObj: null,
    storageBatchObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true, item.redFlushDealStatus == '0' ? true : false]}));
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    DEAILS(state, data) {
      state.detailsObj = data;
    },
    WEIGH_BUSINESS_TYPE(state, data) {
      state.businessTypeObj = data;
    },
    EDITINIT_DATA(state, data) {
      state.editinitDataObj = data;
    },
    SUBMIT_DATA(state, data) {
      state.submitDataObj = data;
    },
    INITPURCHORDER_DATA(state, data) {
      state.initPurchOrderDataObj = data;
    },
    STORAGE_DATA(state, data) {
      state.storageObj = data;
    },
    STORAGE_BATCH_DATA(state, data) {
      state.storageBatchObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async details({commit}, obj) {
      let resp = await details(obj);
      commit('DEAILS', resp);
    },
    async weighBusinessType({commit}, obj) {
      let resp = await weighBusinessType(obj);
      commit('WEIGH_BUSINESS_TYPE', resp);
    },
    async editInit({commit}, obj) {
      let resp = await editInit(obj);
      commit('EDITINIT_DATA', resp);
    },
    async submit({commit}, obj) {
      let resp = await submit(obj);
      commit('SUBMIT_DATA', resp);
    },
    async initPurchOrder({commit}, obj) {
      let resp = await initPurchOrder(obj);
      commit('INITPURCHORDER_DATA', resp);
    },
    async getStorage({commit}, obj) {
      let resp = await storageList(obj);
      commit('STORAGE_DATA', resp);
    },
    async selectStorageBatchByStorageId({commit}, obj) {
      let resp = await selectStorageBatchByStorageId(obj);
      commit('STORAGE_BATCH_DATA', resp);
    },
  }
}
export default weighRedFlush



// WEBPACK FOOTER //
// ./src/page/bd/weighRedFlush/store/weighRedFlush.store.js